class VideoControl extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector("video");
    this.videoPlayPauseButton = this.querySelector("[data-play-pause-button]");
    this.videoMuteButton = this.querySelector("[data-mute-unmute-button]");

    this.video.addEventListener("play", () => {
      this.setAttribute("state", "playing");
    });

    this.video.addEventListener("pause", () => {
      this.setAttribute("state", "paused");
    });

    const play = async () => {
      try {
        await this.video.play();
      } catch (err) {
        console.warn(err);
      }
    };

    this.addEventListener("click", () => {
      this.video.paused ? play() : this.video.pause();
    });

    this.autoplay(play);
  }

  // iOS Safari only autoplays muted inline video, and doesn't reliably apply
  // the muted/autoplay attributes to a <video> inserted from a <template>
  // (load-in-view). Mirror the attributes onto the properties and start it.
  autoplay(play) {
    if (!this.video.hasAttribute("autoplay")) {
      return;
    }

    if (this.video.hasAttribute("muted")) {
      this.video.muted = true;
    }

    this.video.playsInline = true;

    if (!this.video.paused) {
      this.setAttribute("state", "playing");

      return;
    }

    play();
  }

  disconnectedCallback() {}
}

if (!customElements.get("video-control")) {
  customElements.define("video-control", VideoControl);
}
